import { filterControlsEnglish } from "./filterControls";
import { processPageEnglish } from "./processPage";
import { processPanelEnglish } from "./processPanel";
import { sessionStoryEnglish } from "./sessionStory";
import { activityEnglish } from "./activity";
import { english as analysisReportEnglish } from "./analysisReport/english";
import { askEnglish } from "./ask";
import { english as settingsEnglish } from "./settings/english";
import type { ClankTranslation } from "./shared";
import { english as tourEnglish } from "./tour/english";
import { english as watchlistEnglish } from "./watchlist/english";

import { dashboardEnglish } from "./dashboard";

export const english = {
  process_details: "Process details",
  session_details: "Session details",
  interactive_chat: "Interactive Chat",
  page_error: "Error",
  processPage: processPageEnglish,
  processPanel: processPanelEnglish,
  sessionStory: sessionStoryEnglish,
  askPanel: askEnglish,
  activity: activityEnglish,
  dashboard: dashboardEnglish,
  filterControls: filterControlsEnglish,
  Settings: "Settings",
  web_service_limited_functionality_banner:
    "This web service does not include all Platonic features. To map <strong>your</strong> work, use the Platonic desktop application.",
  static_demo_limited_functionality_banner:
    "This demo is a simplified representation of our product. No functionality here is persistent, and all data is synthetic. Contact us for the real product.",
  download_platonic_desktop: "Download Platonic desktop",
  downloads_page: "Downloads",
  downloads_page_description:
    "Download the Platonic desktop application installer for your operating system.",
  downloads_registered_users_only_title: "Downloads are reserved to registered users",
  downloads_registered_users_only_message:
    "The Platonic desktop installer is available after onboarding. Contact us and we will help you activate access for your company.",
  contact_us_for_onboarding: "Contact us",
  downloads_load_failed: "Unable to load downloads",
  no_downloads_available_for_os: "No downloads are currently available for {{os}}.",
  operating_systems: "Operating systems",
  windows: "Windows",
  macos: "macOS",
  linux: "Linux",
  released: "Released",
  download: "Download",
  executive_dashboard: "Administration",
  processes: "Processes",
  recordings: "Sessions",
  close: "Close",
  cancel: "Cancel",
  or: "or",
  submit: "Submit",
  save: "Save",
  loading: "Loading",
  loading_ellipsis: "Loading…",
  generating_graph: "Generating graph…",
  regenerating_graph: "Regenerating graph…",
  graph_layout_failed: "Couldn't lay out the graph. Reload the page to try again.",
  loading_app: "Loading app...",
  user: "User",
  source: "Source",
  what_platonic_records: "What Platonic Captures",
  capture_privacy_summary:
    "Platonic captures periodic screenshots, click and scroll events, keyboard shortcuts and special keys (like Enter, Tab, or Cmd+C), and the title of your active window to understand your workflow steps.",
  no_typed_content: "No typed content",
  no_typed_content_detail: "Platonic does not capture the actual text you type.",
  no_continuous_recording: "No continuous screen recording",
  no_continuous_recording_detail:
    "Platonic saves individual screenshots, not a video of your screen.",
  no_audio_or_microphone: "No audio or microphone",
  no_camera_access: "No camera access",
  language: "Language",
  context: "Context",
  execution_mode: "Execution mode",
  start_recording: "Map my work",
  recording: "Mapping",
  paused: "Paused",
  stopping_recording: "Stopping mapping",
  syncing: "Syncing...",
  unable_to_load_recordings: "Unable to load sessions",
  recordings_update_failed: "Couldn't refresh sessions; the list may be out of date.",
  unable_to_check_updates: "Unable to check for updates",
  api_version_mismatch_title: "Platonic versions do not match",
  api_version_mismatch_remote_newer: "newer",
  api_version_mismatch_remote_older: "older",
  api_version_mismatch_remote_different: "different",
  api_version_mismatch_message:
    "The remote server has a {{relation}} version than this app (server {{remoteVersion}}, local {{localVersion}}). Automatic update download is in progress; expect some functionality to be broken before the update is applied.",
  update_failed: "Update failed",
  analysis_failed: "Analysis failed",
  run_failed: "Run failed",
  failed_to_load_details_for_one_recording: "Failed to load details for 1 session.",
  recording_permissions: "Recording permissions",
  recording_permissions_ready_description: "All permissions for recording are granted.",
  recording_permissions_modal_description:
    "Review the system permissions Platonic needs before recording.",
  recording_permissions_recommended_description:
    "Recording works, but turning on the recommended settings makes recordings more detailed.",
  recording_permissions_restart_title: "Quit and reopen Platonic required",
  recording_permissions_restart_app:
    "After changing Accessibility or other recording permissions, fully quit Platonic and open it again.",
  recording_permissions_load_failed: "Unable to load recording permissions",
  recording_permissions_check_again: "Check again",
  permission_status_granted: "Granted",
  permission_required_for_recording: "Permission needed",
  review_recording_permissions: "Review permissions",
  set_recording_permissions: "Set recording permissions",
  request_permission: "Request",
  open_system_settings: "Settings",
  turn_on_permission: "Turn on",
  accessibility_permission: "Accessibility",
  input_monitoring_permission: "Input Monitoring",
  input_monitoring_blocked_description:
    "Input capture is blocked by macOS. This usually happens when Platonic was explicitly denied in Input Monitoring. Open System Settings > Privacy & Security > Input Monitoring and remove or enable Platonic, then restart Platonic.",
  screen_and_system_audio_recording_permission: "Screen & System Audio",
  desktop_accessibility_permission: "Desktop accessibility",
  desktop_accessibility_description:
    "Lets Platonic record the names of the buttons and fields you use. Apps that were already open when you turn it on need to be restarted to be included.",
  settings: settingsEnglish,
  finalizing_recording: "Processing recording",
  redacting_screenshots: "Redacting the remaining screenshots before upload",
  saved: "saved",
  lost: "lost",
  latest: "Latest",
  step: "step",
  steps: "steps",
  n_steps: "{{count}} steps",
  n_steps_one: "{{count}} step",
  instances: "cases",
  instances_unit: "cases",
  all_instances: "All cases",
  all_n_instances: "All {{count}} cases",
  all_n_instances_one: "{{count}} case",
  n_recordings: "{{count}} sessions",
  n_recordings_one: "{{count}} session",
  selected_n_of_total_instances: '{{count}} of $t(n_instances, {"count": {{total}} }) selected',
  selected_n_of_total_instances_one: '{{count}} of $t(n_instances, {"count": {{total}} }) selected',
  filter_action: "Filter",
  filtering_instances: "Selecting matching cases...",
  filter_failed: "The case filter failed. Please try again.",
  describe_instances_you_want: "Filter cases in plain language...",
  no_instances_match_condition: "Nothing matched that condition.",
  filter_instances: "Filter cases",
  no_matching_steps: "No steps match.",
  remove_filter: "Remove {{label}} filter",
  scope_filter_query: "Matches",
  scope_filter_user: "User",
  scope_filter_date: "Date",
  scope_filter_node: "Step",
  scope_date_from: "from {{date}}",
  scope_date_until: "until {{date}}",
  scope_through_node: "through {{name}}",
  scope_hand_picked: "hand-picked",
  last_n_days: "Last {{count}} days",
  last_n_days_one: "Last {{count}} day",
  scope_date_any: "Select date",
  scope_date_dots_legend: "Cases of this process started that day",
  scope_filter_done: "Done",
  scope_filter_apply: "Apply",
  previous_month: "Previous month",
  next_month: "Next month",
  no_instances_match_scope: "No cases match this scope.",
  scope_criteria_conflict: "{{criteria}} can't both be true.",
  scope_criteria_join: " and ",
  scope_matching_and_selected: "{{matched}} matching · {{included}} selected",
  scope_matching_all_selected: "{{matched}} matching · all selected",
  scope_all_instances: "All {{matched}} cases",
  scope_selected_of_all: "{{included}} of {{matched}} cases selected",
  close_filter_editor: "Close filter",
  scope_criterion_rules_out_everything: "{{criteria}} rules out every case.",
  scope_label: "Scope",
  expand_instances: "Expand cases for",
  collapse_instances: "Collapse cases for",
  succeeded: "Succeeded",
  failed: "Failed",
  running: "Running",
  pending: "Pending",
  cancelled: "Cancelled",
  process: "Process",
  analyze_now: "Analyze",
  analyzing_ellipsis: "Analyzing...",
  no_recordings_available: "No sessions available.",
  loading_recordings: "Loading sessions...",
  authentication_required: "Authentication required",
  browser_login_wait_title: "A browser tab has been opened",
  browser_login_wait_message:
    "Go there and continue the login process. This window will continue automatically when login is complete.",
  browser_login_waiting_status: "Waiting for login...",
  browser_login_complete_status: "Login complete. Returning to Clank...",
  browser_login_done_title: "Login procedure ended",
  browser_login_done_message: "You can safely close this window and return to the app.",
  csrf_validation_failed_missing_header: "CSRF validation failed: missing token.",
  csrf_validation_failed_invalid_header: "CSRF validation failed: invalid token.",
  login_again: "Login again",
  login_again_message:
    "Remote request to server returned error 'unauthenticated'. It is suggested to login again",
  recent_recordings: "Recent Sessions",
  recordings_click_to_view_full_analysis:
    "{{count}} sessions captured · Click to view full analysis",
  recordings_click_to_view_full_analysis_one:
    "{{count}} session captured · Click to view full analysis",
  uploading_recording_data: "Uploading session data...",
  syncing_recording: "Syncing session",
  sync_failed: "Sync failed",
  no_analyzed_recordings_available_yet: "No analyzed sessions available yet.",
  recording_archived: "Archived",
  recording_active: "Active",
  current_user: "You",
  recording_filter_scope: "Show",
  recording_filter_all: "All",
  rename_recording: "Rename",
  archive_recording: "Archive",
  unarchive_recording: "Unarchive",
  archive_recording_tooltip:
    "Archived sessions remain available under Archived or All, but are excluded from the overview and process reporting.",
  unarchive_recording_tooltip:
    "Restore this session to the active list, overview and process reporting.",
  recording_archive_update_failed: "Failed to update archive state",
  archived_recordings_match_filters_one:
    "There is {{count}} archived session matching your filters.",
  archived_recordings_match_filters: "There are {{count}} archived sessions matching your filters.",
  show_archived_recordings: "Show archived",
  select_recording: "Select session",
  select_all_recordings_on_page: "Select all on this page",
  recordings_selected_one: "{{count}} session selected",
  recordings_selected: "{{count}} sessions selected",
  clear_selection: "Clear selection",
  bulk_actions: "Bulk actions",
  archive_selected_recordings: "Archive selected",
  unarchive_selected_recordings: "Unarchive selected",
  delete_selected_recordings: "Delete selected",
  bulk_archive_recordings_title_one: "Archive {{count}} session?",
  bulk_archive_recordings_title: "Archive {{count}} sessions?",
  bulk_unarchive_recordings_title_one: "Unarchive {{count}} session?",
  bulk_unarchive_recordings_title: "Unarchive {{count}} sessions?",
  bulk_delete_recordings_title_one: "Delete {{count}} session?",
  bulk_delete_recordings_title: "Delete {{count}} sessions?",
  bulk_archive_recordings_message:
    "These sessions will remain available under Archived or All, but will be excluded from the overview and process reporting.",
  bulk_unarchive_recordings_message:
    "These sessions will be restored to the active list, overview and process reporting.",
  bulk_delete_recordings_message:
    "The following sessions will be removed from remote storage and Platonic. This cannot be undone.",
  bulk_delete_analyzing_notice_one:
    "{{count}} session is still being analyzed and will not be deleted. Stop its analysis first if you want to delete it.",
  bulk_delete_analyzing_notice:
    "{{count}} sessions are still being analyzed and will not be deleted. Stop their analyses first if you want to delete them.",
  bulk_recording_update_failed_one:
    "Failed to update {{count}} session. It remains selected so you can retry.",
  bulk_recording_update_failed:
    "Failed to update {{count}} sessions. They remain selected so you can retry.",
  bulk_recording_delete_failed_one:
    "Failed to delete {{count}} session. It remains selected so you can retry.",
  bulk_recording_delete_failed:
    "Failed to delete {{count}} sessions. They remain selected so you can retry.",
  delete_recording: "Delete session",
  delete_recording_title: "Delete session?",
  delete_recording_message: "This removes the session. This cannot be undone.",
  delete_recording_message_synced:
    "This removes the session from remote storage and Platonic. This cannot be undone.",
  delete_recording_message_local:
    "This removes the session from this computer. This cannot be undone.",
  acknowledge_delete_recording: "I understand this cannot be undone.",
  confirm_delete_recording: "Delete permanently",
  recording_delete_failed: "Failed to delete session",
  recording_import: "Session import",
  recording_import_card_description:
    "Create or replace a session analysis from a validated JSON result.",
  import_recording_analysis: "Import session analysis",
  edit_recording_analysis: "Edit session analysis",
  recording_import_description:
    "Paste a complete analysis result JSON. Platonic will validate it and compute the session dates.",
  failed_to_load_recording_import_data: "Failed to load session import data",
  loading_recording_import_data: "Loading session import data...",
  failed_to_save_recording_analysis: "Failed to save session analysis",
  you_do_not_have_permission_to_import_recordings:
    "You do not have permission to import session analyses.",
  select_user_for_recording_import: "Select the user this session belongs to.",
  recording_name: "Session name",
  include_imported_recording_in_processes: "Include this session in process generation",
  recording_import_no_existing_analysis:
    "This session does not have a completed analysis result yet. Paste the full replacement JSON.",
  analysis_result_json: "Analysis result JSON",
  analysis_result_json_help:
    "Paste the complete analysis result object. It must match the backend AnalyticsData schema.",
  save_recording_analysis: "Save session analysis",
  app_menu: "Menu",
  recording_deletion_started:
    "Deletion started. This is a long operation; come back later to check.",
  recording_deletion_already_in_progress:
    "A deletion operation is already in progress. Come back later to check deletion completion.",
  expand_sidebar: "Expand sidebar",
  go_back: "Go back",
  go_forward: "Go forward",
  collapse_sidebar: "Collapse sidebar",
  resize_sidebar: "Drag to resize · double-click to reset",
  no_data: "No data",
  end_stream: "End stream",
  unknown: "unknown",
  ended: "Ended",
  refuse: "Refuse",
  initial_app_load_failed: "Error during the initial loading of the app",
  retry: "Retry",
  created: "Created",
  started: "Started",
  manual_interventions: "Manual interventions",
  trigger_entity: "Trigger entity",
  extra_context: "Extra context",
  group: "Group",
  thinking: "Thinking...",
  overview: "Overview",
  timeline: "Timeline",
  missing_analytics_identifier_in_url: "Missing analytics identifier in URL.",
  unable_to_load_recording_data: "Unable to load session data",
  loading_recording: "Loading session...",
  recording_not_found_title: "Session not found",
  recording_not_found_message:
    "This session does not exist or you do not have permission to view it.",
  back_to_recordings: "Back to sessions",
  analyzing_recording: "Analyzing session...",
  stop_analysis: "Stop analysis",
  stopping_analysis: "Stopping...",
  failed_to_stop_analysis: "Failed to stop analysis",
  something_went_wrong_you_can_retry_the_analysis:
    "Something went wrong. You can retry the analysis.",
  this_recording_has_not_been_analyzed_yet: "This session has not been analyzed yet.",
  analysis_cancelled_page_message: "The analysis was cancelled. You can start it again.",
  recording_too_short: "Too short",
  analysis_runs: "Analysis runs",
  analysis_run_pill_label: "Analysis run",
  analysis_run_latest: "latest",
  rerun_analysis: "Re-run analysis",
  rerunning_ellipsis: "Re-running...",
  rerun_failed: "Re-run failed",
  rerun_progress_title: "Re-analysis in progress",
  rerun_progress_message: "The session keeps showing the previous result until this run finishes.",
  rerun_progress_waiting: "Waiting for the analyzer to report progress...",
  view_rerun_progress: "View re-analysis progress",
  rename_analysis_run: "Rename run",
  analysis_run_rename_message:
    "Name this run so you can tell it apart from the session's other runs.",
  analysis_run_name_placeholder: "Name this run",
  analysis_run_rename_failed: "Failed to rename the analysis run",
  delete_analysis_run: "Delete run",
  delete_analysis_run_message:
    "This deletes only this analysis run. The session and its other runs are kept.",
  delete_last_analysis_run_message:
    "This is the session's only analysis. The session itself is kept, and will show as not analyzed until you run the analysis again.",
  analysis_run_delete_failed: "Failed to delete the analysis run",
  compare_analysis_runs: "Compare runs",
  compare_with_run_unavailable: "A failed run kept no result to compare",
  compare_run_on_other_band: "Already shown in the other band",
  compare_pick_two_runs: "Select two runs to compare",
  compare_run_band: "Run {{side}}: {{name}}",
  change_run: "Change run",
  compare_run_load_failed: "Failed to load the run being compared",
  rerun_from_run: "Re-run from this run",
  rerun_from_run_named: "Re-run from run “{{name}}”",
  rerun_from_run_unavailable: "This run kept no artifacts to re-run from",
  rerun_from_run_message: "The stages before the one you start at are copied from this run.",
  analysis_rerun_failed: "Failed to start the analysis re-run",
  rerun_selected_recordings: "Re-run analysis on selected",
  rerun_recordings_title: "Re-run analysis",
  rerun_recordings_message:
    "Each selected session is analyzed again. The current results stay on display until a re-run finishes.",
  recording_too_short_page_message: "We need at least 60 seconds of activity to analyze a session.",
  retry_analysis: "Retry Analysis",
  view_analysis: "View analysis",
  analyze: "Analyze",
  no_recording_data_available: "No session data available.",
  recording_session: "Work Session",
  local_recording_unavailable: "Mapping your work is available only in the Platonic desktop app.",
  activity_feed: "Activity Feed",
  live_activity_captured_during_recording: "Live activity captured during the session.",
  no_feed_events_yet: "No feed activities yet.",
  back_to_previous_page: "Back to previous page",
  request_failed: "Request failed",
  invalid_request: "The request is invalid.",
  invalid_form: "Some form fields are invalid.",
  invalid_form_with_fields: "Some form fields are invalid: {{fields}}.",
  invalid_form_field: "{{field}} {{errors}}",
  form_field_missing: "Field is required",
  form_field_invalid_type: "has the wrong type",
  form_field_invalid_value: "has an invalid value",
  form_field_invalid_foreign_key: "Select a valid option",
  form_field_invalid_email: "Enter a valid email address",
  form_field_value_too_long: "Must be at most {{max}} characters",
  form_field_value_too_big: "Must be at most {{max}}",
  form_field_value_too_short: "Must be at least {{min}} characters",
  form_field_value_too_small: "Must be at least {{min}}",
  form_field_password_missing_lowercase: "Include a lowercase letter",
  form_field_password_missing_uppercase: "Include an uppercase letter",
  form_field_password_missing_digit: "Include a number",
  form_field_password_missing_symbol: "Include a symbol, such as !, @, #, or .",
  form_field_password_too_weak: "Choose a stronger password",
  invalid_json: "The request body is not valid JSON.",
  invalid_websocket_upgrade: "The websocket upgrade request is invalid.",
  invalid_password: "The password does not meet the security requirements.",
  invalid_path_parameter: "The URL parameter {{parameter}} is invalid.",
  invalid_query_parameter: "The query parameter {{parameter}} is invalid.",
  unsupported_value: "The value for {{field}} is not supported.",
  permission_denied_reason: {
    generic: "You do not have permission to perform this action.",
    missing_recording_permission: "Platonic needs the {{permission}} permission to record.",
    admin_required: "Only admins can perform this action.",
    manage_users_required: "You do not have permission to manage users.",
    create_users_required: "You do not have permission to create users.",
    manage_vocabulary_required: "You do not have permission to manage company vocabulary.",
    manage_prompts_required: "You do not have permission to configure prompts.",
    own_recording_required: "You can only edit your own recordings.",
    recording_delete_forbidden: "You cannot delete this recording.",
    recording_owner_access_forbidden:
      "You cannot access recordings for this user with your permissions.",
    analysis_diagnostics_forbidden: "You do not have permission to view analysis diagnostics.",
    analysis_runs_forbidden:
      "You do not have permission to work with this recording's analysis runs.",
    reanalyze_recording_forbidden:
      "You do not have permission to re-analyze an already analyzed recording.",
    recording_screenshot_forbidden: "You cannot access screenshots for this recording.",
    sync_model_id_forbidden: "You cannot create a {{model}} with this id.",
    sync_model_read_only: "Company and user sync models are read only.",
    release_proxy_repo_forbidden:
      "You cannot access a repository outside platonic-research/clank-core.",
  },
  too_many_requests: "Too many requests. {{details}}",
  conflict: "The request conflicts with the current state.",
  analysis_already_running:
    "This recording is already being analyzed. Wait for that analysis to finish, or stop it, before starting another.",
  service_temporarily_unavailable: "The service is temporarily unavailable.",
  answer_too_long: "The answer was too long to deliver. Please ask a narrower question.",
  unexpected_error: "An unexpected error occurred.",
  resource_not_found: "{{resource}} not found{{lookup}}.",
  resource_conflict: "{{resource}} already exists{{lookup}}.",
  api_error_lookup_by_field: " for {{field}} {{value}}",
  api_error_lookup_by_fields: " for {{fields}}",
  api_error_lookup_unspecified: "",
  resource_kind_user: "User",
  resource_kind_company: "Company",
  resource_kind_alert: "Alert",
  resource_kind_recording: "Session",
  resource_kind_recording_command: "Session command",
  resource_kind_recording_event_log: "Session event log",
  resource_kind_recording_os_permission: "Recording permission",
  resource_kind_process: "Process",
  resource_kind_process_instance: "Case",
  resource_kind_workflow: "Workflow",
  resource_kind_workflow_version: "Workflow version",
  resource_kind_ran_workflow: "Workflow run",
  resource_kind_oidc_provider: "OIDC provider",
  resource_kind_sync_model: "Sync model",
  resource_kind_vocabulary_entry: "Vocabulary entry",
  resource_kind_prompt_snippet: "Prompt snippet",
  resource_kind_prompt_slot: "Prompt slot",
  resource_kind_object: "Object",
  resource_kind_classification_category: "Category",
  back: "Back",
  failed_to_load_process: "Failed to load process",
  process_detail: "Process Detail",
  observed: "observed",
  total_duration: "Total duration",
  steps_per_instance_full: "Average steps per case",
  also_seen_as: "Also seen as",
  chat: "Chat",
  ask: "Ask",
  step_details: "Step details",
  transition_details: "Transition details",
  node_hover_hint: "Process step: click for details",
  process_graph_label: "Process graph",
  browse_all_processes: "Browse all processes",
  sort_processes: "Sort processes",
  feedback: {
    title: "Share feedback",
    description:
      "Your feedback goes straight to the Platonic team. Context from this page is included automatically.",
    message_label: "Your feedback",
    message_placeholder:
      "What were you trying to do?\nWhat felt unclear, slow, or surprising?\nWhat would have made it better?",
    take_screenshot: "Take screenshot",
    taking_screenshot: "Taking screenshot...",
    attach_image: "Attach image",
    drop_image: "Drop image to attach",
    remove_screenshot: "Remove screenshot",
    screenshot_alt: "Attached screenshot",
    submit: "Send feedback",
    sent_title: "Thanks for your feedback",
    sent_description: "Your feedback was sent to the Platonic team.",
  },
  process_directory: {
    favourites_hint: "Only processes you have starred.",
    feedback_title: "Missing a process or spotted something incorrect?",
    feedback_hint: "Your feedback helps make Platonic more accurate.",
    feedback_action: "Share feedback",

    subtitle_team: "Explore the work your team does. Open a process to see how it happens.",
    subtitle_personal: "Explore your work. Open a process to see how it happens.",
    group_frequency: "Frequency",
    bucket_favourites: "Favourites",
    bucket_not_favourites: "Other processes",
    group_intensity: "Time intensity",
    bucket_frequent: "Frequent ({{minimum}}+)",
    bucket_occasional: "Occasional (up to {{maximum}})",
    bucket_long: "Time intensive",
    bucket_short: "Less time intensive",
    long_hint: "Average case duration of at least one hour.",
    short_hint: "Average case duration below one hour.",
    group_by: "Group by",
    group_none: "None",
    group_domain: "Business domain",
    group_pattern: "Process pattern",
    bucket_unclassified: "Not classified",
    unclassified_hint: "Analysed before processes were classified.",
    unknown_category: "Unknown category",
    group_person: "Person",
    group_application: "Application",
    unknown_application: "Application unavailable",
    time_unavailable: "Time unavailable",
    time_in_app: "Time in app",
    time_in_app_hint:
      "Time spent in this app during the process, and its share of the process's total time.",
    share_of_team: "Share of team",
    share_of_team_hint: "This person's share of the team's total time on the process.",
    share_of_team_detail: "{{duration}} of the team's {{total}}",
    time_in_app_detail: "{{duration}} in {{app}}, of {{total}} total",
    group_app_duration: "{{duration}} in {{app}}",
    from_grouping: "From grouping",
    hidden_by_person_grouping: "Hidden while grouped by person",
    clear_filters: "Clear filters",
    sort_within_groups: "Sort within groups",
    sort_by: "Sort by",
    sort_recent: "Most recently observed",
    sort_shared: "Most shared",
    process: "Process",
    people: "People",
    case_count: "Case count",
    tools: "Apps",
    instances: "Cases",
    avg_duration: "Avg. duration",
    total_time: "Total time",
    last_observed: "Last observed",
    placeholder_description: "Process description coming soon.",
    placeholder_hint: "Temporary description",
    unknown_person: "Unknown person",
    unavailable: "Not available",
    open_process: "Open {{name}}",
    open: "Open process",
    group_count_one: "{{count}} process",
    group_count_other: "{{count}} processes",
    group_total_duration: "{{duration}} total",
    directory_count: "{{groups}} process groups · {{count}} processes",
    show_more: "Show {{count}} more",
    show_less: "Show less",
    total_time_hint: "Cumulative observed time across cases; concurrent work may overlap.",
    median_duration: "Median duration",
    avg_steps: "Avg. steps",
    display: "Display",
    columns: "Columns",
    reset_display: "Reset to default",
    display_customized: "Customized",
  },
  process_sort_frequency: "Most frequent",
  process_sort_name: "Name (A–Z)",
  process_sort_duration: "Longest average duration",
  switch_process: "Switch process",
  zoom_in: "Zoom in",
  zoom_out: "Zoom out",
  search_steps: "Search steps",
  previous_search_match: "Previous match",
  next_search_match: "Next match",
  no_search_matches: "0/0",
  close_search: "Close search",
  set_zoom_percentage: "Set zoom percentage",
  view_controls: "View controls",
  app: "App",
  times: "Times",
  process_instance_n: "Case {{num}}",
  scope_instance_count: "{{selected}} of {{total}} cases",
  process_more_actions: "More actions",
  process_watch: "Watch",
  show_process_details: "Show process details",
  hide_process_details: "Hide process details",
  compare_runs: "Compare cases",
  compare_run_a: "Case A",
  compare_run_b: "Case B",
  compare_choose_run: "Choose a case…",
  compare_runs_help: "Choose two cases from the current selection.",
  compare: "Compare",
  exit_compare: "Exit compare",
  watch_this_process: "Watch this process",
  comparing: "Comparing",
  compare_with: "Compare with",
  switch_instance: "Switch case",
  instances_in_scope: "Cases in scope",
  compare_pick_side: "Compare against",
  compare_swap_sides: "Swap sides",
  compare_metric: "Metric",
  compare_delta: "Δ",
  compare_total_duration: "Duration",
  compare_total_duration_help: "Duration explained",
  compare_total_duration_help_text:
    "Only the active time spent on the steps. The waits between steps are not counted.",
  compare_waiting_time: "Waits between steps",
  compare_waiting_time_help: "Waits between steps explained",
  compare_waiting_time_help_text:
    "The sum of the observed gaps between one step ending and the next one starting.",
  compare_steps: "Steps",
  compare_rework: "Repeated steps",
  compare_step_flow: "Step by step",
  compare_shared_steps: "{{count}} steps shared",
  compare_shared_steps_one: "{{count}} step shared",
  compare_focus_step: "Show {{step}}",
  compare_step_skipped: "Not taken in this case",
  compare_show_step_detail: "Show what {{label}} did here",
  compare_hide_step_detail: "Hide what {{label}} did here",
  graph_settings: "Graph settings",
  advanced: "Advanced",
  color: "Color",
  color_by: "Color by",
  color_none: "None",
  color_time: "Duration",
  step_reading: "Show on steps",
  step_reading_help:
    "Automatic shows cases while traffic is on, and visits with average time otherwise.",
  step_reading_auto: "Automatic",
  step_reading_visits_avg: "Visits · avg time",
  step_reading_total_time: "Total time",
  step_reading_cases: "Cases",
  step_reading_none: "Nothing",
  edge_routing: "Connections",
  edge_routing_bundled: "Bundled",
  edge_routing_separate: "Separate",
  edge_routing_help:
    "Bundled merges arrows that share a step into one trunk that splits where the flows diverge.",
  traffic: "Traffic",
  traffic_help:
    "Draws each connection thicker the more often cases took it, and marks the longest waits. Off by default.",
  traffic_off: "Off",
  traffic_on: "On",
  reset_view: "Reset view",
  fit_to_screen: "Fit to screen",
  time_share: "Time share",
  time_share_matching_instances_help: "About time share",
  time_share_matching_instances_tooltip:
    "Fraction of time spent in this step in cases where it showed up.",
  decision_step: "Decision step",
  app_usage: "App usage",
  step_next_steps: "Next steps",
  transition: "Transition",
  transitions: "Transitions",
  focus_transition: "Focus transition from {{from}} to {{to}}",
  edge_departures_label: "Departures",
  edge_departures_help: "About departures",
  edge_departures_tooltip:
    "Share of departures from the source step that followed this transition.",
  edge_average_wait_label: "Avg wait",
  edge_average_wait_help: "About average wait",
  edge_average_wait_tooltip:
    "Average time between the source step ending and the following step starting.",
  branches: "Branches",
  n_cases: "{{count}} cases",
  n_cases_one: "{{count}} case",
  ask_why: "Ask why",
  ask_why_time_sink: "Ask why {{step}} takes so much time",
  ask_why_waiting_time: "Ask why there is a wait from {{from}} to {{to}}",
  ask_why_transition: "Ask why {{from}} transitions to {{to}}",
  ask_why_duration_variability: "Ask why process durations vary so much",
  ask_branching_prompt:
    "Why does “{{name}}” branch into these different next steps, and what factors determine which path is taken?",
  ask_transition_prompt: "Why does “{{from}}” transition to “{{to}}” in {{percentage}}% of cases?",
  ask_time_sink_prompt:
    "Why does “{{name}}” account for {{percentage}}% of process time, and where is that time being spent within this step?",
  ask_waiting_time_prompt:
    "This transition occurred {{count}} times and has an average observed waiting time of {{duration}}. Were the waits between “{{from}}” and “{{to}}” due to unrelated activity, or to preliminary work required to start the next step? Compare the longest waits with typical cases and identify the conditions generating them.",
  ask_waiting_time_single_prompt:
    "This transition occurred once, with an observed waiting time of {{duration}}. Was the {{duration}} wait between “{{from}}” and “{{to}}” due to unrelated activity, or to preliminary work required to start the next step?",
  ask_duration_variability_prompt:
    "Why do cases of “{{name}}” vary so much in duration? Compare the longest cases with typical ones, identify the steps or conditions driving the difference, and explain where the additional time is spent.",
  ask_about_instance: "Ask about this case",
  ask_why_compare_metric: "Ask why {{metric}} differs between {{a}} and {{b}}",
  ask_compare_count_metric_prompt:
    "I am comparing two cases of “{{process}}”: {{a}} and {{b}}. On {{metric}}, {{a}} reads {{aValue}} and {{b}} reads {{bValue}} ({{delta}} for {{b}}). What accounts for that difference — which conditions in the two cases explain it?",
  ask_compare_metric_prompt:
    "I am comparing two cases of “{{process}}”: {{a}} and {{b}}. On {{metric}}, {{a}} reads {{aValue}} and {{b}} reads {{bValue}} ({{delta}} for {{b}}). What accounts for that difference — which steps or conditions in the two cases explain it?",
  ask_about: "Ask about",
  ask_instance_prompt:
    "Walk me through what happened in “{{name}}”, step by step, and flag anything unusual or worth a closer look.",
  duration_analytics: "Duration analytics",
  duration_distribution: "Duration histogram",
  median: "Median",
  trend_over_time: "Trend over time",
  start: "Start",
  end: "End",
  duration: "Duration",
  duration_avg: "Duration (avg)",
  traces_begin_here: "traces begin here",
  traces_end_here: "traces end here",
  occurrences: "Occurrences",
  step_occurrence: "Step occurrence",
  occurrence_position: "{{current}}/{{total}}",
  occurrence_position_accessible: "Occurrence {{current}} of {{total}}",
  previous_occurrence: "Previous occurrence",
  next_occurrence: "Next occurrence",
  step_position_long: "Step {{current}} of {{total}}",
  step_position_compact: "Step {{current}}/{{total}}",
  step_position_start: "Start",
  step_position_end: "End",
  instance_view: "Case details",
  open_occurrence_instance_hint: "Open case at this occurrence ({{label}})",
  instances_through_step_title: "Cases through this step",
  instances_through_transition_title: "Cases through this transition",
  open_instance_view_hint: "Open case details for {{label}}",
  view_instance_action: "View",
  back_to_overview: "Back to the process overview",
  back_to_step_details: "Back to step details",
  back_to_transition_details: "Back to transition details",
  instance_steps_chronological: "Case steps in chronological order",
  instance_step_keys_hint: "Move through the steps",
  instance_step_keys_hint_sides: "Switch case",
  instance_step_keys_hint_enter: "See the details",
  instance_wait_gap: "{{duration}} wait",
  instance_wait_gap_between: "Wait of {{duration}} between “{{from}}” and “{{to}}”",
  ask_why_waiting_time_gap: "Ask why there is a {{duration}} wait from {{from}} to {{to}}",
  open_instance_recording: "Open {{instance}} session",
  objects: "Objects",
  screenshots: "Screenshots",
  no_description: "No description for this occurrence.",
  no_objects: "No objects for this occurrence.",
  expand_section: "Expand {{section}}",
  collapse_section: "Collapse {{section}}",
  show_more: "Show more",
  show_less: "Show less",
  time_allocation: "Time Allocation",
  by_process: "by process",
  by_app: "by app",
  other_apps: "Other apps",
  idle: "Away from keyboard / mapping paused",
  process_breakdown: "Process Breakdown",
  filter_by_app: "Filter by app",
  all_apps: "All apps",
  add_app: "Add app",
  remove_app_filter: "Remove {{app}} filter",
  showing_n_of_m_processes: "Showing {{shown}} of {{count}} processes",
  showing_n_of_m_processes_one: "Showing {{shown}} of {{count}} process",
  instances_of_total: "{{shown}} of {{count}} cases",
  instances_of_total_one: "{{shown}} of {{count}} case",
  n_instances: "{{count}} cases",
  n_instances_one: "{{count}} case",
  n_processes: "{{count}} processes",
  n_processes_one: "{{count}} process",
  percent_in_app: "{{pct}}% in {{app}}",
  no_instances_use_app: "No cases use {{app}}.",
  no_meaningful_process_was_found: "No meaningful process was found.",
  irrelevant_processes: "Unstructured activity",
  session_timeline: "Session Timeline",
  events_per_process_trace: "Steps per Process Trace",
  process_trace: "Process Trace",
  events: "Steps",
  avg_length: "Avg Length",
  discovered_processes: "Discovered Processes",
  processes_across_your_recordings: "{{count}} processes across analyzed sessions",
  processes_across_your_recordings_one: "{{count}} process across analyzed sessions",
  failed_to_load_processes: "Failed to load processes",
  add_process_to_favourites: "Add {{name}} to favourites",
  remove_process_from_favourites: "Remove {{name}} from favourites",
  add_to_favourites: "Add to Favourites",
  remove_from_favourites: "Remove from Favourites",
  favourites: "Favourites",
  no_processes_discovered_yet_record_some_sessions_first:
    "No processes discovered yet. Map some work first.",
  recorded: "mapped",
  useless: "useless",
  update_required: "Update Required",
  platonic_is_ready_to_install: "Platonic {{version}} is ready to install",
  the_update_has_already_been_downloaded_installation_must_be_completed_before_continuing:
    "The update has already been downloaded. Installation must be completed before continuing.",
  release_notes: "Release Notes",
  install_update_now: "Install update now",
  stop_recording_and_install_update: "Stop recording and install update",
  page_not_found: "Page not found",
  no_results_for: "No results for",
  connection_to_ws_lost: "Connection to WS lost",
  already_trying_to_reconnect_please_wait: "Already trying to reconnect, please wait.",
  app_loading_redirect_soon: "App is still loading, you will be redirected soon...",
  arguments: "Arguments",
  details: "Details",
  description: "Description",
  executive_dashboard_description: "Tools for managing users and sessions.",
  user_management: "User management",
  manage_users_description: "Browse users and create new accounts.",
  user_management_description:
    "Review company users and create a new user with default permissions.",
  users: "Users",
  companies: "Companies",
  loading_users: "Loading users...",
  company: "Company",
  loading_companies: "Loading companies...",
  companies_count: "{{count}} companies",
  companies_count_one: "{{count}} company",
  users_count: "{{count}} users",
  users_count_one: "{{count}} user",
  create_company: "Create company",
  create_company_description: "Create a company that users can be assigned to.",
  creating_company: "Creating company...",
  company_created: "Company created.",
  company_id: "Company ID",
  company_name: "Company name",
  company_logo_url: "Logo URL",
  allow_password_login: "Allow password login",
  allow_password_login_description: "Users in this company can sign in with username and password.",
  create_user: "Create user",
  create_user_description: "Create a new company user.",
  creating_user: "Creating user...",
  enroll_user: "Enroll user",
  enroll_user_description: "Create a user and send them an enrollment email.",
  enrolling_user: "Enrolling user...",
  user_enrollment_sent: "Enrollment email sent.",
  send_enrollment_email: "Send enrollment email",
  send_enrollment_email_to_user: "Send enrollment email to {{username}}",
  send_enrollment_email_confirmation: "The enrollment email will be sent to {{email}}.",
  enrollment_resets_password_warning: "This will reset the user's password.",
  enrollment_onboarding_email_warning:
    "This will send the same onboarding email used for a first-time user.",
  enrollment_existing_missing_email:
    "This user has no email address, so an enrollment email cannot be sent.",
  impersonate_user: "Impersonate user",
  impersonate_user_help:
    "Create a browser session as another user. This replaces your current session in this browser.",
  select_user_to_impersonate: "Select user to impersonate",
  start_impersonation: "Start impersonation",
  username: "Username",
  password: "Password",
  email: "Email",
  first_name: "First name",
  last_name: "Last name",
  name: "Name",
  actions: "Actions",
  edit_company: "Edit company",
  save_company: "Save company",
  password_login_enabled: "Enabled",
  password_login_disabled: "Disabled",
  edit_user: "Edit user",
  save_user: "Save user",
  manage_user_permissions: "Manage permissions",
  user_permissions: "User permissions",
  user_permissions_description: "Review and update this user's access rules.",
  save_user_permissions: "Save permissions",
  permissions_updated: "Permissions updated.",
  back_to_user_management: "Back to user management",
  failed_to_load_user_permissions: "Failed to load user permissions",
  failed_to_update_user_permissions: "Failed to update user permissions",
  selected_user_not_found: "Selected user not found",
  simplified_permission_form: "Simplified permission form",
  admin_user: "Admin user",
  recordings_permissions: "Session permissions",
  processes_permissions: "Process permissions",
  screenshots_permissions: "Screenshot permissions",
  users_permissions: "User permissions",
  can_create_users: "Can create users",
  permission_scope: "Scope",
  permission_only_mine: "Only mine",
  permission_all_company: "All company",
  permission_specific_users: "Specific users",
  permission_all: "All users",
  specific_users: "Specific users",
  new_password_optional: "New password (optional)",
  confirm_password: "Confirm password",
  back_to_executive_dashboard: "Back to Administration",
  failed_to_load_users: "Failed to load users",
  failed_to_load_companies: "Failed to load companies",
  failed_to_create_user: "Failed to create user",
  failed_to_enroll_user: "Failed to enroll user",
  failed_to_update_user: "Failed to update user",
  failed_to_update_company: "Failed to update company",
  passwords_do_not_match: "Passwords do not match.",
  you_do_not_have_permission_to_create_users: "You do not have permission to create users.",
  you_do_not_have_permission_to_create_companies: "You do not have permission to create companies.",
  you_do_not_have_permission_to_edit_companies: "You do not have permission to edit companies.",
  you_do_not_have_permission_to_edit_users: "You do not have permission to edit users.",
  show_n_screenshots: "Show {{count}} screenshots",
  show_n_screenshots_one: "Show {{count}} screenshot",
  failed_to_load_screenshot: "Failed to load screenshot",
  screenshot_n_of_total: "Screenshot {{current}} of {{total}}",
  previous_screenshot: "Previous screenshot",
  next_screenshot: "Next screenshot",
  play_screenshot_autoplay: "Play screenshots",
  pause_screenshot_autoplay: "Pause screenshots",
  screenshot_playback_speed: "Playback speed",
  start_at_stage: "Start from stage",
  use_lift_tools: "Use LLM tools",
  filters: "Filters",
  search_people: "Search people…",
  people_you: "{{name}} (You)",
  people_only_you: "Only you",
  search_in_processes: "Search in processes…",
  search_recordings: "Search by name…",
  from: "From",
  to: "To",
  min: "Min",
  max: "Max",
  step_count: "Step count",
  repetitions: "Repetitions",
  clear_all_filters: "Clear all filters",
  no_results_match_filters: "No results match your filters.",
  showing_n_of_total: "Showing {{filtered}} of {{total}}",
  chat_back_to_details: "Back to details",
  chat_close_sidebar: "Close sidebar",
  chat_across_sessions: "Ask across sessions",
  sessions_scope: "Sessions scope",
  my_sessions: "My sessions",
  team_sessions: "Team sessions",
  sessions_navigator: "Session navigator",
  sessions_latest: "Latest session",
  sessions_view: "Sessions view",
  sessions_empty_scope: "No sessions in this view. Try Active, Archived or All.",
  sessions_timeline_group: "{{count}} sessions",
  sessions_timeline_reset: "Reset to 7 days around the selected session",
  sessions_timeline_days: "{{count}} days",
  sessions_timeline_days_one: "{{count}} day",
  sessions_timeline_help: "Scroll to browse · Ctrl + scroll to zoom",
  sessions_empty_personal: "Your sessions will appear here after you map your work.",
  sessions_previous: "Previous session",
  sessions_next: "Next session",
  sessions_session: "Session",
  sessions_date_time: "Date and time",
  sessions_analysis: "Analysis",
  sessions_analysis_ready: "Ready",
  sessions_not_analyzed: "Not analyzed",
  chat_this_session: "This session",
  chat_alert_paused: "Alert paused",
  chat_pause_alert: "Pause alert",
  chat_resume_alert: "Resume alert",
  chat_manage_alert: "Edit alert",
  chat_alert_update_failed: "Could not update the alert. Try again.",
  chat_history_empty: "No conversations yet.",
  chat_recent: "History",
  chat_expand: "Expand conversation",
  chat_collapse: "Back to sidebar",
  chat_following_page: "Following page",
  chat_custom_context: "Custom context",
  chat_use_session: "Use this session",
  chat_use_runs: "Use these cases",
  chat_selected_runs: "{{count}} selected cases",
  chat_change_selection: "Change selection",
  chat_session_processes: "All processes in this session",
  chat_panel_modes: "Process panel",
  chat_details: "Details",
  chat_ask_result: "Ask a follow-up",
  chat_ask_result_hint: "Dig into this result in Ask, with the report attached as context.",
  chat_alert_result: "Alert result",
  chat_result_data: "Saved result. The filters below select data for follow-up questions.",
  chat_result_scope_unknown:
    "Original data selection unavailable: the filters below use the current alert settings around this result’s date.",
  chat_alert_example_duration: "Tell me when average case duration increases.",
  chat_alert_example_manual: "Summarize time spent on manual data entry.",
  chat_alert_example_rework: "Highlight steps that are being repeated more often.",
  chat_follow_page: "Use page selection",
  chat_change_context: "Change",
  chat_custom_context_help:
    "Or choose people, processes and a rolling period for your next questions. This replaces the page selection.",
  chat_apply_context: "Use this context",
  chat_kpi_scope_help:
    "Choose what to track and answer any follow-up questions. Your KPI will be created automatically, and you can edit it in Insights.",
  chat_kpi_process_help:
    "This alert will check all cases of the selected process. Selected steps and individual cases are not retained.",
  chat_kpi_session_help:
    "This alert will check new sessions. Choose whose work to monitor and the lookback period below.",
  chat_kpi_creating: "Creating KPI…",
  chat_kpi_retry: "Retry creating KPI",
  chat_kpi_review_failed: "Could not prepare your KPI. Please try again.",
  chat_kpi_saved: "KPI created",
  chat_kpi_saved_help: "You can edit this KPI anytime in Insights.",
  chat_kpi_view: "View KPI",
  chat_back_to_conversation: "Conversation",
  chat_track_this: "Track this as a KPI",
  chat_track_this_hint: "Re-run this question on a schedule and follow how the answer changes.",
  chat_track_this_dismiss: "Hide KPI suggestion",
  chat_opens_sidebar: "Opens Ask in the sidebar",
  chat_new_question: "New conversation",
  chat_scope_label: "Ask about",
  chat_scope_changed: "Scope changed to: {{label}}",
  chat_selected_steps: "Selected steps",
  chat_remove_selected_step: "Remove {{step}} from chat context",
  chat_ask_tooltip:
    "These filters apply to your next question. Your conversation keeps its context when you navigate to another page.",
  chat_ephemeral_warning: "This chat is temporary and will be lost when the app restarts.",
  chat_getting_long: "This conversation is getting long. Start a new one to keep answers fast.",
  chat_too_long: "This conversation is too long to continue. Start a new one to keep asking.",
  chat_too_many_messages:
    "This conversation has reached its message limit. Start a new one to keep asking.",
  chat_input_mentions_placeholder: "Ask about this data… Type @ for context",
  chat_input_placeholder: "Ask about this data…",
  chat_ai_disclaimer:
    "Answers are AI-generated and may contain mistakes. Verify important information.",
  chat_send: "Send",
  chat_stop: "Stop",
  chat_copy: "Copy",
  chat_copied: "Copied",
  chat_quote_in_reply: "Quote in reply",
  chat_error_generic: "The assistant could not answer. Please try again.",
  chat_static_demo_unavailable: "This feature works only on the real release of Platonic.",
  chat_dismiss_error: "Dismiss",
  chat_thinking_analyzing_process_context: "Analyzing process context...",
  chat_thinking_listing_recordings: "Listing sessions...",
  chat_thinking_reading_recording_metadata: "Reading session metadata...",
  chat_thinking_reading_process_instances: "Reading cases...",
  chat_thinking_inspecting_analysis_details: "Inspecting analysis details...",
  chat_thinking_searching_in_nodes: "Searching in analysis nodes...",
  chat_thinking_computing_node_metrics: "Computing metrics...",
  chat_thinking_analyzing_screenshots: "Analyzing screenshots...",
  chat_thinking_running_subagents: "Running subagents...",
  chat_thinking_reasoning: "Thinking...",
  chat_thinking_preparing_final_answer:
    "Preparing an answer with the information already gathered...",
  chat_suggestion_time_sink: "What is the biggest time sink?",
  chat_suggestion_differences: "Where do the cases differ the most?",
  chat_suggestion_summary: "Summarize this process for a new team member.",
  chat_with_recording: "Chat with session",
  chat_new_conversation: "Clear chat and start a new one",
  chat_suggestion_recording_time: "Where did the time go in this session?",
  chat_suggestion_recording_summary: "Summarize what was done in this session.",
  chat_suggestion_recording_unstructured: "What happened outside the main processes?",
  analysisReport: analysisReportEnglish,
  vocabulary: "Vocabulary",
  vocabulary_page_description:
    "The process and step names the analysis prefers when labeling sessions. Contributions guide future analyses only.",
  add_to_vocabulary: "Standardize names",
  vocabulary_scope_label: "Applies to",
  vocabulary_scope_user: "Only my analyses",
  vocabulary_scope_company: "Whole company",
  change_vocabulary: "Edit standard names",
  vocabulary_updating_entry: "Saving…",
  vocabulary_names_saved: "Names saved",
  vocabulary_blank_name: "A name can’t be blank. Fill it in or leave it out.",
  vocabulary_no_names: "Check at least one step name before saving.",
  vocabulary_popover_title: "Make these the standard names in future sessions",
  vocabulary_popover_lede:
    "Next time this work shows up, the analysis labels it with the names checked below instead of inventing new ones. This doesn’t affect past analyses.",
  vocabulary_popover_help: "How this works",
  vocabulary_popover_process_label: "Name for this process",
  vocabulary_popover_steps_label: "Names for its steps",
  vocabulary_saved_steps_label: "Names already saved",
  vocabulary_new_steps_label: "New names in this analysis",
  vocabulary_select_all: "Select all",
  vocabulary_select_none: "Clear all",
  vocabulary_save_names: "Save these names",
  vocabulary_override_hint: "A definition for this process already exists. Saving replaces it.",
  vocabulary_scope_badge_builtin: "built-in",
  vocabulary_scope_badge_personal: "personal",
  vocabulary_overridden_definitions: "{{count}} overridden definitions",
  vocabulary_overridden_definitions_one: "{{count}} overridden definition",
  vocabulary_create_override: "Override",
  vocabulary_edit_entry: "Edit",
  vocabulary_new_entry: "New entry",
  vocabulary_process_name: "Process name",
  vocabulary_steps_hint: "Steps (one per line)",
  vocabulary_add_entry: "Add entry",
  vocabulary_adding_entry: "Adding…",
  vocabulary_delete_entry: "Delete",
  vocabulary_empty: "No vocabulary entries yet.",
  vocabulary_contributed_by_you: "you",
  vocabulary_scope_badge_company: "company-wide",
  failed_to_load_vocabulary: "Failed to load vocabulary",
  vocabulary_categories: "Categories",
  vocabulary_processes: "Processes",
  n_categories: "{{count}} categories",
  n_categories_one: "{{count}} category",
  vocabulary_categories_description:
    "The categories each analysis sorts steps and processes into. Archived ones are kept for past analyses but not used for new ones.",
  category_kind_step_type: "Step types",
  category_kind_business_domain: "Business domains",
  category_kind_process_pattern: "Process patterns",
  category_name: "Name",
  category_description: "Description",
  category_add: "Add category",
  category_archive: "Archive",
  category_unarchive: "Restore",
  category_archived_badge: "archived",
  category_min_active: "Each list needs at least {{count}} active categories.",
  prompt_config_title: "Prompt configuration",
  prompt_config_card_description: "Edit the prompt text analyses and chats run with.",
  prompt_config_description:
    "Each prompt is built from a fixed structure with editable sections. Saving a section stores a new version and applies it to the whole company from the next run; resetting returns the section to its built-in text.",
  prompt_config_no_permission: "You do not have permission to configure prompts.",
  prompt_config_customized: "customized",
  prompt_config_built_in: "built-in",
  prompt_config_snippet_name: "Version label",
  prompt_config_slot_text: "Section text",
  prompt_config_company_label: "Configure prompts for",
  prompt_config_all_companies: "All companies (deployment defaults)",
  prompt_config_deployment_text: "deployment override",
  prompt_config_tab_assignments: "Assignments",
  prompt_config_tab_snippets: "Snippets",
  prompt_config_option_built_in: "Built-in text",
  prompt_config_option_inherit: "No company override",
  prompt_config_new_snippet: "New snippet",
  prompt_config_new_version: "New version",
  prompt_config_delete_snippet_hint:
    "Delete this version and those derived from it; slots using them fall back",
  prompt_config_show_text: "Show text",
  prompt_config_hide_text: "Hide text",
  prompt_config_no_snippets: "No snippets stored yet.",
  prompt_config_version_label: "Version",
  prompt_config_save_and_apply: "Save and apply",
  prompt_config_apply_target: "Will be applied to {{target}}",
  send: "Send",
  pause: "Pause",
  resume: "Resume",
  edit: "Edit",
  delete: "Delete",
  person: "Person",
  people: "People",
  weekly: "Weekly",
  minutes_ago: "{{count}}m ago",
  hours_ago: "{{count}}h ago",
  days_ago: "{{count}}d ago",
  custom_ellipsis: "Custom…",
  analysis_ready_title: "{{count}} sessions ready for analysis",
  analysis_ready_title_one: "Session ready for analysis",
  analysis_ready_description:
    "Your upload is complete. Analyze your sessions to discover processes and app usage.",
  analysis_ready_action: "View sessions to analyze",
  review_ready_title: "{{count}} sessions ready to review",
  review_ready_title_one: "Session ready to review",
  review_recordings_title: "Sessions awaiting your review",
  review_recordings_subtitle:
    "Nothing leaves this computer until you approve it. Review the screenshots, then approve upload or delete.",
  review_today: "Today",
  review_yesterday: "Yesterday",
  review_approve_all: "Approve all and upload ({{count}})",
  review_approved: "Approved. Uploading {{count}} sessions…",
  review_approved_one: "Approved. Uploading your session…",
  review_deleted: "Session deleted.",
  review_all_caught_up: "All caught up",
  review_details: "Apps and activity",
  review_approve_recording: "Approve and upload",
  review_screenshots: "Review screenshots",
  review_screenshots_hint: "View screenshots and exclude any you don't want uploaded",
  review_exclude_screenshot: "Exclude",
  review_include_screenshot: "Include",
  review_n_excluded: "{{count}} excluded",
  review_exclude_confirm_title: "Delete {{excluded}} of {{count}} screenshots before upload?",
  review_exclude_confirm_title_one: "Delete {{excluded}} of {{count}} screenshot before upload?",
  review_exclude_confirm_description:
    "The excluded screenshots are permanently deleted from this computer. The rest of the session is uploaded.",
  review_upload_all_confirm_title: "Upload the whole session?",
  review_upload_all_confirm_description:
    "No screenshots are excluded: everything recorded in this session is uploaded.",
  review_n_screenshots: "{{count}} screenshots",
  review_n_screenshots_one: "{{count}} screenshot",
  review_n_events: "{{count}} events",
  review_n_events_one: "{{count}} event",
  review_n_clicks: "{{count}} clicks",
  review_n_clicks_one: "{{count}} click",
  review_n_shortcuts: "{{count}} shortcuts",
  review_n_shortcuts_one: "{{count}} shortcut",
  review_n_typed_chars: "{{count}} characters typed",
  review_n_typed_chars_one: "{{count}} character typed",
  review_apps_heading: "Apps and windows",
  review_no_apps: "No app activity recorded",
  review_untitled_window: "(untitled window)",
  review_more_window_titles: "+{{count}} more",
  review_excluded_apps: "Excluded apps",
  review_excluded_apps_total: "{{duration}} total",
  review_excluded_apps_hint: "Nothing was recorded while these apps were active.",
  tour: tourEnglish,
  watchlist: watchlistEnglish,
} satisfies ClankTranslation;
